export enum CorrugatedCartonBoxesFields {
  type = "type",
  length = "length",
  width = "width",
  height = "height",
  material = "material",
  otherMaterial = "otherMaterial",
  mainColor = "mainColor",
  numberOfPrintColors = "numberOfPrintColors",
  designFile = "designFile",
  typeFile = "typeFile",
  amountPcs = "amountPcs",
}
